import { useQuery } from "./useApi.js";
import { awards } from "../api/awards.service.js";

/**
 * Filter dropdown options for the staff Awards list — the dictionary values,
 * years and jurisdiction countries at least one award actually uses.
 *
 * Fetched once per page mount (empty dependency list): the set only changes when
 * an import or an edit lands, and the next visit picks that up. The awards list
 * itself never waits for this call and never fails with it — while it is in
 * flight, or if it fails, the page keeps the dictionary dropdowns disabled and
 * the list keeps loading, the same degradation `useCountryNames` applies to
 * country labels.
 */
export function useAwardFilterOptions() {
  return useQuery(() => awards.getFilterOptions(), []);
}
